import { emptySplitApi as api } from "./emptyApi"
import {
  AgendaControllerListApiResponse,
  AgendaControllerListApiArg,
  AgendaControllerGetApiResponse,
  AgendaControllerGetApiArg,
  AgendaControllerCreateApiResponse,
  AgendaControllerCreateApiArg,
  AgendaControllerUpdateApiResponse,
  AgendaControllerUpdateApiArg,
  AgendaControllerDeleteApiResponse,
  AgendaControllerDeleteApiArg,
  AgendaControllerAddLinkApiResponse,
  AgendaControllerAddLinkApiArg,
  AgendaControllerUpdateLinkApiResponse,
  AgendaControllerUpdateLinkApiArg,
  AgendaControllerDeleteLinkApiResponse,
  AgendaControllerDeleteLinkApiArg,
} from "./types/agenda.types"

const injectedRtkApi = api.injectEndpoints({
  endpoints: build => ({
    agendaControllerList: build.query<
      AgendaControllerListApiResponse,
      AgendaControllerListApiArg
    >({
      query: queryArg => ({
        url: `/agenda`,
        params: {
          from: queryArg.from,
          to: queryArg.to,
          type: queryArg.type,
          status: queryArg.status,
          assigneeId: queryArg.assigneeId,
        },
      }),
      providesTags: ["AgendaSlots"],
    }),
    agendaControllerGet: build.query<
      AgendaControllerGetApiResponse,
      AgendaControllerGetApiArg
    >({
      query: queryArg => ({ url: `/agenda/${queryArg.id}` }),
      providesTags: ["AgendaSlots"],
    }),
    agendaControllerCreate: build.mutation<
      AgendaControllerCreateApiResponse,
      AgendaControllerCreateApiArg
    >({
      query: queryArg => ({
        url: `/agenda`,
        method: "POST",
        body: queryArg.createAgendaSlotDto,
      }),
      invalidatesTags: ["AgendaSlots"],
    }),
    agendaControllerUpdate: build.mutation<
      AgendaControllerUpdateApiResponse,
      AgendaControllerUpdateApiArg
    >({
      query: queryArg => ({
        url: `/agenda/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.updateAgendaSlotDto,
      }),
      invalidatesTags: ["AgendaSlots"],
    }),
    agendaControllerDelete: build.mutation<
      AgendaControllerDeleteApiResponse,
      AgendaControllerDeleteApiArg
    >({
      query: queryArg => ({
        url: `/agenda/${queryArg.id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["AgendaSlots"],
    }),
    agendaControllerAddLink: build.mutation<
      AgendaControllerAddLinkApiResponse,
      AgendaControllerAddLinkApiArg
    >({
      query: queryArg => ({
        url: `/agenda/${queryArg.id}/links`,
        method: "POST",
        body: queryArg.createAgendaSlotLinkDto,
      }),
      invalidatesTags: ["AgendaSlots"],
    }),
    agendaControllerUpdateLink: build.mutation<
      AgendaControllerUpdateLinkApiResponse,
      AgendaControllerUpdateLinkApiArg
    >({
      query: queryArg => ({
        url: `/agenda/${queryArg.id}/links/${queryArg.linkId}`,
        method: "PATCH",
        body: queryArg.updateAgendaSlotLinkDto,
      }),
      invalidatesTags: ["AgendaSlots"],
    }),
    agendaControllerDeleteLink: build.mutation<
      AgendaControllerDeleteLinkApiResponse,
      AgendaControllerDeleteLinkApiArg
    >({
      query: queryArg => ({
        url: `/agenda/${queryArg.id}/links/${queryArg.linkId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["AgendaSlots"],
    }),
  }),
  overrideExisting: false,
})
export { injectedRtkApi as agendaApi }

// Export hooks
export const {
  useAgendaControllerListQuery,
  useAgendaControllerGetQuery,
  useAgendaControllerCreateMutation,
  useAgendaControllerUpdateMutation,
  useAgendaControllerDeleteMutation,
  useAgendaControllerAddLinkMutation,
  useAgendaControllerUpdateLinkMutation,
  useAgendaControllerDeleteLinkMutation,
} = injectedRtkApi

// Re-export types needed by components
export type {
  AgendaSlotDto,
  AgendaSlotType,
  AgendaSlotStatus,
  AgendaSlotLinkDto,
  AgendaSlotLinkStatus,
  CreateAgendaSlotDto,
  UpdateAgendaSlotDto,
  CreateAgendaSlotLinkDto,
  UpdateAgendaSlotLinkDto,
  ListAgendaSlotsArg,
} from "./types/agenda.types"
